module.exports = __webpack_public_path__ + "img/sleeve flounce length.4d005dd2.png";